import { useEffect, useState } from "react";
import { useTranslation } from 'react-i18next';

export const useLocalization = () => {
    const { t, i18n } = useTranslation();    
    const [language, setLanguge] = useState(i18n.language);

    const languageChanged = (lang) => {
        // languageChangedCallback(language);
        setLanguge(lang);
    }

    useEffect(() => {
        i18n.on("languageChanged", languageChanged);
        return () => {
            i18n.off("languageChanged", languageChanged);
        }
    }, [i18n])
    
    return {t, i18n, language};
}
